var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"#FAFAFA"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('app-navigation'),_c('v-content',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1),_c('app-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }